// Beeplii — small interactions
(function () {
  // Mobile nav
  const toggle = document.querySelector('.mobile-toggle');
  const links = document.querySelector('.nav-links');
  if (toggle && links) {
    const setOpen = (open) => {
      links.classList.toggle('open', open);
      document.body.classList.toggle('nav-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    };
    toggle.addEventListener('click', () => setOpen(!links.classList.contains('open')));
    links.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setOpen(false)));
    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && links.classList.contains('open')) setOpen(false);
    });
  }

  // Scroll-to-top button
  const scrollTopBtn = document.querySelector('.scroll-top');
  if (scrollTopBtn) {
    const SHOW_AFTER = 500; // pixels scrolled before button appears
    let ticking = false;
    const updateBtn = () => {
      const shouldShow = window.scrollY > SHOW_AFTER;
      scrollTopBtn.hidden = false; // reveal element so transition can run
      scrollTopBtn.classList.toggle('is-visible', shouldShow);
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateBtn);
        ticking = true;
      }
    }, { passive: true });
    scrollTopBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      scrollTopBtn.blur();
    });
    updateBtn();
  }

  // Scroll reveal
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -80px 0px', threshold: 0.05 });
    document.querySelectorAll('[data-reveal]').forEach(el => io.observe(el));
  } else {
    document.querySelectorAll('[data-reveal]').forEach(el => el.classList.add('in'));
  }

  // PDP gallery
  const thumbs = document.querySelectorAll('.pdp-thumbs button');
  const main = document.querySelector('.pdp-gallery .main-img img');
  if (thumbs.length && main) {
    thumbs.forEach((b, i) => {
      b.addEventListener('click', () => {
        thumbs.forEach(x => x.classList.remove('active'));
        b.classList.add('active');
        const img = b.querySelector('img');
        if (img) {
          main.style.opacity = 0;
          setTimeout(() => {
            main.src = img.dataset.full || img.src;
            main.alt = img.alt || '';
            main.style.opacity = 1;
            updateSceneState();
          }, 180);
        }
      });
    });
    main.style.transition = 'opacity 0.25s ease';
    // Scene/lifestyle images (e.g. the child photo) display full-bleed, no gradient.
    var SCENE_RE = /p1-gallery-(3|8)\./;
    function updateSceneState() {
      if (main && main.parentElement) {
        main.parentElement.classList.toggle('is-scene', SCENE_RE.test(main.src));
      }
    }
    // tag scene thumbnails too
    thumbs.forEach(function (b) {
      var ti = b.querySelector('img');
      if (ti && SCENE_RE.test(ti.src)) ti.classList.add('is-scene-thumb');
    });
    updateSceneState();
  }

  const mainWrap = document.querySelector('.pdp-gallery .main-img');

  // PDP hover magnify (Amazon-style): on desktop, hovering the main image
  // zooms in and the view pans to follow the cursor. Touch devices skip this
  // and use the click lightbox below instead.
  if (mainWrap && main) {
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (canHover) {
      const ZOOM = 4;
      mainWrap.addEventListener('mouseenter', () => {
        mainWrap.classList.add('magnify');
        main.style.transition = 'transform 0.15s ease-out, filter 0.2s ease';
        main.style.transform = 'scale(' + ZOOM + ')';
      });
      mainWrap.addEventListener('mousemove', (e) => {
        const r = mainWrap.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width) * 100;
        const y = ((e.clientY - r.top) / r.height) * 100;
        main.style.transformOrigin = x + '% ' + y + '%';
      });
      mainWrap.addEventListener('mouseleave', () => {
        mainWrap.classList.remove('magnify');
        main.style.transform = '';
        main.style.transformOrigin = 'center center';
        main.style.transition = 'opacity 0.25s ease';
      });
    }
  }

  // PDP click-to-zoom lightbox (full-screen view; also the touch fallback)
  if (mainWrap && main) {
    const lb = document.createElement('div');
    lb.className = 'pdp-lightbox';
    lb.innerHTML =
      '<button class="pdp-lightbox__close" aria-label="Close">&times;</button>' +
      '<div class="pdp-lightbox__stage"><img alt=""></div>' +
      '<div class="pdp-lightbox__hint"></div>';
    document.body.appendChild(lb);
    const stage = lb.querySelector('.pdp-lightbox__stage');
    const lbImg = lb.querySelector('img');
    const closeBtn = lb.querySelector('.pdp-lightbox__close');

    const open = () => {
      lbImg.src = main.src;
      lbImg.alt = main.alt || '';
      stage.classList.remove('zoomed');
      lbImg.style.transform = '';
      lb.classList.add('open');
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      lb.classList.remove('open');
      document.body.style.overflow = '';
      stage.classList.remove('zoomed');
      lbImg.style.transform = '';
    };

    mainWrap.addEventListener('click', open);

    // Device-aware hint
    var hintEl = lb.querySelector('.pdp-lightbox__hint');
    var isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
    hintEl.textContent = isTouch
      ? 'Tap to zoom · drag to pan · ✕ to close'
      : 'Click to zoom · move to pan · Esc to close';

    var ZOOM_SCALE = 2.4;
    function panTo(clientX, clientY) {
      var r = stage.getBoundingClientRect();
      var x = Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
      var y = Math.max(0, Math.min(100, ((clientY - r.top) / r.height) * 100));
      lbImg.style.transformOrigin = x + '% ' + y + '%';
    }
    // Track movement so a pan-drag isn't mistaken for a zoom tap
    var downX = 0, downY = 0, moved = false;
    stage.addEventListener('pointerdown', (e) => { downX = e.clientX; downY = e.clientY; moved = false; });
    // Pan works for mouse-move (desktop) AND touch-drag (mobile)
    stage.addEventListener('pointermove', (e) => {
      if (Math.abs(e.clientX - downX) > 6 || Math.abs(e.clientY - downY) > 6) moved = true;
      if (!stage.classList.contains('zoomed')) return;
      if (e.pointerType === 'touch') e.preventDefault();
      panTo(e.clientX, e.clientY);
    });
    stage.addEventListener('click', (e) => {
      e.stopPropagation();
      if (moved) return; // it was a drag-to-pan, not a tap
      var zoomed = stage.classList.toggle('zoomed');
      if (!zoomed) { lbImg.style.transform = ''; lbImg.style.transformOrigin = 'center center'; return; }
      panTo(e.clientX, e.clientY);
      lbImg.style.transform = 'scale(' + ZOOM_SCALE + ')';
    });

    closeBtn.addEventListener('click', close);
    lb.addEventListener('click', (e) => { if (e.target === lb) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  // Qty stepper
  document.querySelectorAll('.qty-stepper').forEach(s => {
    const input = s.querySelector('input');
    const dec = s.querySelector('[data-qty="-"]');
    const inc = s.querySelector('[data-qty="+"]');
    if (!input) return;
    dec && dec.addEventListener('click', () => { input.value = Math.max(1, (+input.value || 1) - 1); });
    inc && inc.addEventListener('click', () => { input.value = (+input.value || 1) + 1; });
  });

  // Newsletter forms post natively to Shopify ({% form 'customer' %}).
  // (Removed the prototype "display-only" intercept that blocked real signups, 2026-06-05.)

  // Cart toy (just counts)
  let cart = 0;
  document.querySelectorAll('[data-add-cart]').forEach(btn => {
    btn.addEventListener('click', () => {
      cart += parseInt(document.querySelector('.qty-stepper input')?.value || 1, 10);
      const badge = document.querySelector('.cart-count');
      if (badge) badge.textContent = cart;
      btn.textContent = 'Added to gift box ✦';
      setTimeout(() => { btn.textContent = btn.dataset.label || 'Add to gift box'; }, 1800);
    });
  });

  // Logo pink-dot positioning (measures each tspan and re-centers the matching circle)
  function positionBeepliiDots() {
    document.querySelectorAll('.logo-svg').forEach(svg => {
      const stems = svg.querySelectorAll('.logo-i-glyph');
      const dots  = svg.querySelectorAll('.logo-pink-dot');
      stems.forEach((stem, i) => {
        const dot = dots[i];
        if (!dot) return;
        try {
          const bb = stem.getBBox();
          dot.setAttribute('cx', bb.x + bb.width / 2);
        } catch (e) {}
      });
    });
  }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(positionBeepliiDots);
  }
  window.addEventListener('load', positionBeepliiDots);
  setTimeout(positionBeepliiDots, 100);
  setTimeout(positionBeepliiDots, 500);
  setTimeout(positionBeepliiDots, 1500);
})();
